import { I_LOCALE_FILTERS_PROPERTIES } from "../util/filters.util";
import I_PropertyFiltersServer from "../../../qrtk/services/realestate/values/list_realestate.value";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

const ConvertToServerFiltersProperty = (
  values: I_LOCALE_FILTERS_PROPERTIES
) => {
  const filters: I_LOCALE_FILTERS_PROPERTIES = values;

  const filtersServer: I_PropertyFiltersServer = {};

  if (filters?.cities_property?.length > 0) {
    filtersServer.city = filters.cities_property
      .map((city: any) => city.value)
      .join(",");
  }

  if (filters?.sector_property?.length > 0) {
    filtersServer.sector = filters.sector_property
      .map((sector: any) => sector.value)
      .join(",");
  }

  if (filters?.parking_property) {
    filtersServer.parkings = filters.parking_property
      .map(x => x)
      .join(",");
  }

  if (filters?.bedroom_property) {
    filtersServer.bedrooms = filters.bedroom_property
      .map(x => x)
      .join(",");
  }
  if (filters?.bathroom_property) {
    filtersServer.bathrooms = filters.bathroom_property
      .map(x => x)
      .join(",");
  }

  if (filters?.level_floor_property) {
    filtersServer.floorLevels = filters.level_floor_property
      .map(x => x)
      .join(",");
  }
  if (filters?.price_min_property && !filters?.price_max_property) {
    filtersServer.price = `>=${filters.price_min_property},${filters.currency_price_property[0].value}`;
  }
  if (!filters?.price_min_property && filters?.price_max_property) {
    filtersServer.price = `<=${filters.price_max_property},${filters.currency_price_property[0].value}`;
  }
  if (filters?.price_min_property && filters?.price_max_property) {
    filtersServer.price = `${filters.price_min_property}...${filters.price_max_property},${filters.currency_price_property[0].value}`;
  }
  if (
    filters?.maintenance_min_property &&
    !filters?.maintenance_max_property
  ) {
    filtersServer.maintenancePrice = `>=${filters.maintenance_min_property},${filters.maintenance_currency_property}`;
  }
  if (
    !filters?.maintenance_min_property &&
    filters?.maintenance_max_property
  ) {
    filtersServer.maintenancePrice = `<=${filters.maintenance_max_property},${filters.maintenance_currency_property}`;
  }
  if (
    filters?.maintenance_min_property &&
    filters?.maintenance_max_property
  ) {
    filtersServer.maintenancePrice = `${filters.maintenance_min_property}...${filters.maintenance_max_property},${filters.maintenance_currency_property}`;
  }

  //
  if (
    filters?.meters_land_max_property.length > 1 &&
    filters?.meters_land_min_property.length < 1
  ) {
    filtersServer.landSize = `>=${filters.meters_land_max_property}`;
  }
  if (
    filters?.meters_land_min_property.length > 1 &&
    filters?.meters_land_max_property.length < 1
  ) {
    filtersServer.landSize = `<=${filters.meters_land_min_property}`;
  }
  if (
    filters?.meters_land_min_property.length > 1 &&
    filters?.meters_land_max_property.length > 1
  ) {
    filtersServer.landSize = `${filters.meters_land_min_property}...${filters.meters_land_max_property}`;
  }
  if (
    filters?.meters_construction_max_property.length > 1 &&
    filters?.meters_construction_min_property.length < 1
  ) {
    filtersServer.constructionSize = `>=${filters.meters_construction_max_property}`;
  }
  if (
    filters?.meters_construction_max_property.length < 1 &&
    filters?.meters_construction_min_property.length > 1
  ) {
    filtersServer.constructionSize = `<=${filters.meters_construction_min_property}`;
  }
  if (
    filters?.meters_construction_min_property.length > 1 &&
    filters?.meters_construction_max_property.length > 1
  ) {
    filtersServer.constructionSize = `${filters.meters_construction_min_property}...${filters.meters_construction_max_property}`;
  }

  if (filters?.status_property?.length > 0) {
    filtersServer.status = filters.status_property
      .map((status: I_GENERIC_ITEMS) => status?.value)
      .join(",");
  }
  if (filters?.type_property?.length > 0) {
    filtersServer.type = filters.type_property
      .map((type: I_GENERIC_ITEMS) => type.value)
      .join(",");
  }

  if (filters?.business_type_property?.length > 0) {
    filtersServer.business = filters.business_type_property
      .map(business => business.value)
      .join(",");
  }
  if (filters?.detail_type_property?.length > 0) {
    filtersServer.extraBusinessTypes = filters.detail_type_property
      .map((detail: I_GENERIC_ITEMS) => detail.id)
      .join(",");
  }

  if (filters?.improvements_property?.length > 0) {
    filtersServer.feature = filters.improvements_property
      .map((improvements: I_GENERIC_ITEMS) => improvements.value)
      .join(",");
  }

  if (filters?.condition_property?.length > 0) {
    filtersServer.condition = filters.condition_property
      .map((condition: I_GENERIC_ITEMS) => condition.value)
      .join(",");
  }

  if (filters?.agents_property?.length > 0) {
    filtersServer.agent = filters.agents_property
      .map((x: I_GENERIC_ITEMS) => x.value)
      .join(",");
  }

  if (filters?.agencies_property?.length > 0) {
    filtersServer.agency = filters.agencies_property
      .map((x: I_GENERIC_ITEMS) => x.value)
      .join(",");
  }
  if (filters?.my_properties) {
    filtersServer.own = filters.my_properties ? true : false;
  }
  if (filters?.page) {
    filtersServer.page = filters.page;
  }

  if (filters.search) {
    filtersServer.search = filters?.search?.trimEnd()?.trimStart();
  }

  if (filters?.fideicomiso_property?.length > 0) {
    filtersServer.trustName = filters.fideicomiso_property
      .map((x: I_GENERIC_ITEMS) => x.value)
      .join(",");
  }

  if (filters?.percent_commission_property) {
    filtersServer.commission = `>=${filters.percent_commission_property}`;
  }

  if (filters.delivers) {
    filtersServer.delivers = filters.delivers;
  }
  if (filters.is_collection_property) {
    filtersServer.onlyCollection = filters.is_collection_property;
  }

  return filtersServer;
};
export default ConvertToServerFiltersProperty;
